<template>
  <div class="source-cover" :key="source.name">
    <div class="source-cover--type">
      {{ source ? source.sourceType : "" }}
    </div>

    <NavigatorWithTitle
      :key="landingIndex"
      :prev="prev"
      :next="next"
      :title="source.name"
      :landingIndex="landingIndex"
      class="source-cover__nav"
    />
    <YellowLine class="source-cover__line" :landingIndex="landingIndex" />
    <Slider
      :sources="sources"
      :landingIndex="landingIndex"
      class="source-cover__slider"
    />

    <CtaButton
      :label="content.cta"
      labelSB="download PDF"
      @clickFunctionExplore="goToSource()"
      @clickFunctionDownload="download()"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import NavigatorWithTitle from "./coverComponents/NavigatorWithTitle.vue";
import Slider from "./coverComponents/Slider.vue";
import YellowLine from "./coverComponents/YellowLine.vue";
import CtaButton from "./coverComponents/CtaButton.vue";
export default {
  name: "SourceCover",
  components: { NavigatorWithTitle, Slider, YellowLine, CtaButton },
  computed: {
    contentButton() {
      return this.$t("landing").downloadBtn;
    },
    content() {
      return this.$t("sourceCover");
    },
    source() {
      return this.sources[this.landingIndex];
    },
    prev() {
      return this.sources[this.landingIndex - 1]
        ? this.sources[this.landingIndex - 1]
        : null;
    },
    next() {
      return this.sources[this.landingIndex + 1]
        ? this.sources[this.landingIndex + 1]
        : null;
    },
    ...mapGetters({
      landingIndex: "scroller/landingIndex",
      sources: "ui/mainSourcesRegistry",
    }),
  },
  methods: {
    download() {
      const pdf = this.contentButton.href;
      window.open(pdf, "_blank").focus();
    },
    async goToSource() {
      this.setMainSource(this.sources[this.landingIndex].key);
      await new Promise((r) => setTimeout(r, 10));
      this.$router.push("/" + this.source.key);
    },
    ...mapActions({
      setMainSource: "ui/setMainSource",
    }),
  },
};
</script>

<style lang="scss" scoped>
.source-cover {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: white;
  height: fit-content;
  margin-top: 10%;

  &--type {
    min-height: 17px;
    margin-bottom: toRem(10);
    @include dida-M;
  }

  &__nav {
    margin-bottom: toRem(17);
  }

  &__line {
    margin-bottom: toRem(24);
  }

  &__slider {
    margin-bottom: toRem(25);
  }
}

.tablet {
  .source-cover {
    margin-top: 10%;

    &--type {
      @include dida-L;
      line-height: 0;
    }

    &__nav {
      margin-bottom: toRem(38);
    }

    &__line {
      margin-bottom: toRem(45);
    }

    &__slider {
      margin-bottom: toRem(41.68);
    }
  }
}
</style>
